<owc-modal-dialog disable-backdrop-click disable-escape-keydown disable-scroll-lock hide-backdrop no-auto-focus visible>
    <owc-component-header slot="header">
       <div class="header-right-section">
         <h3>Mac Address Request Completed</h3>
         <div class="action-icons">
           <owc-icon-button icon="print" (click)="printPage()"></owc-icon-button>
           <owc-icon-button icon="copy" (click)="copyToClipboard()"></owc-icon-button>
         </div>
       </div>
    </owc-component-header>
    <div class="modal-content">
      <span>The MAC-Address for the provided serial number(s) are as following.</span>
      <div class="mac-address-result-table">
        <owc-table [size]="'small'" [rounded]="true" [showRowExpanderColumn]="true">
          <owc-table-header sticky>
            <owc-table-header-cell [width]="'auto'" [align]="'left'" [resizable]="true" [sortable]="false"
              [sortOrder]="'asc'" [valign]="'middle'">serial number</owc-table-header-cell>
            <owc-table-header-cell [width]="'auto'" [align]="'left'" [resizable]="true" [sortable]="false"
              [sortOrder]="'asc'" [valign]="'middle'">MAC-Address</owc-table-header-cell>
          </owc-table-header>
          <owc-table-body>
            <owc-table-row *ngFor="let data of dataSource">
              <owc-table-cell>{{data.serialno}}</owc-table-cell>
              <owc-table-cell>
                <span class='mac-address-result-modal__content--error-text' *ngIf='!!data?.error; else macAddress'>
                  {{data?.error | errorMessage}}
                </span>
                <ng-template #macAddress>
                  {{data.macaddress | uppercase}}
                </ng-template>
              </owc-table-cell>
            </owc-table-row>
          </owc-table-body>
        </owc-table>
      </div>
    </div>
    <owc-component-footer slot="footer">
       <div class="action-button">
          <owc-button (click)="closePopup()">Close</owc-button>
       </div>
    </owc-component-footer>
 </owc-modal-dialog>
 
 <div id="print-section" style="display: none;">
   <dl-print-mac-address-result [tableData]="dataSource"></dl-print-mac-address-result>
 </div>
 